export const makeFullLink = (link: string) => {
  if (window?.location?.origin) {
    return `${window.location.origin}${link}`;
  }

  return link;
};
